import { render, staticRenderFns } from "./warn_record_form.vue?vue&type=template&id=0fdb7f3f"
import script from "./warn_record_form.vue?vue&type=script&lang=js"
export * from "./warn_record_form.vue?vue&type=script&lang=js"
import style0 from "./warn_record_form.vue?vue&type=style&index=0&id=0fdb7f3f&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdb7f3f')) {
      api.createRecord('0fdb7f3f', component.options)
    } else {
      api.reload('0fdb7f3f', component.options)
    }
    module.hot.accept("./warn_record_form.vue?vue&type=template&id=0fdb7f3f", function () {
      api.rerender('0fdb7f3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/warnrecord/warn_record_form.vue"
export default component.exports